export const inputDiv = "text-left mb-2"